/** Small flat records read like a receipt; complex evidence keeps its exact JSON. */
export function ToolData({ value }: { value: unknown }) {
  const entries =
    value && typeof value === 'object' && !Array.isArray(value) ? Object.entries(value) : [];
  if (
    entries.length > 0 &&
    entries.length <= 8 &&
    entries.every(
      ([, item]) =>
        item === null ||
        typeof item === 'number' ||
        typeof item === 'boolean' ||
        (typeof item === 'string' && item.length <= 240),
    )
  ) {
    return (
      <dl className="pc-tool-data">
        {entries.map(([key, item]) => (
          <div key={key}>
            <dt>{key.replace(/_/g, ' ')}</dt>
            <dd>{item === null ? 'null' : String(item)}</dd>
          </div>
        ))}
      </dl>
    );
  }
  return (
    <pre tabIndex={0} className="pc-tool-json">
      {typeof value === 'string' ? value : JSON.stringify(value, null, 2)}
    </pre>
  );
}

export function ToolInputData({ text }: { text: string }) {
  let value: unknown = text;
  try {
    value = JSON.parse(text);
  } catch {
    /* Partial streamed input stays verbatim. */
  }
  return <ToolData value={value} />;
}
